import { render, staticRenderFns } from "./EstadoCuentaPublic.vue?vue&type=template&id=25cf24e9&"
import script from "./EstadoCuentaPublic.vue?vue&type=script&lang=ts&"
export * from "./EstadoCuentaPublic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports